import React from 'react';
import CRUDDetailPage from '../../../shared/components/crud/CRUDDetailPage';
import { appointmentConfig } from '../config/appointmentConfig';
import { AppointmentService } from '../../../shared/services/appointmentService';

/**
 * AppointmentDetail - URL-based detail page for Appointments
 * Handles view, edit, and add modes with ID from URL params
 */
export default function AppointmentDetail() {
  return (
    <CRUDDetailPage
      config={appointmentConfig}
      service={AppointmentService}
    />
  );
}
